(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-consolidated"] && !Shopify.designMode) return;
  try {
    if (!window.__pccAtcInit) {
    window.__pccAtcInit = true;
    /* Add to cart the way this theme does it: AJAX add + cart:update event so the drawer refreshes and opens.
       Capture phase so no other grid script can swallow the click. */
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-pcc-atc-btn]') : null;
        if (!btn || btn.disabled) return;
        var form = btn.closest('form.pcc-atc');
        if (!form) return;
        e.preventDefault();
        e.stopPropagation();

        var fd = new FormData(form);
        fd.delete('return_to');
        var ids = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
        });
        if (ids.length) fd.append('sections', ids.join(','));

        var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch(url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.message || 'Could not add to cart');
            btn.textContent = 'Added';
            try {
              form.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: res,
                    sourceId: 'pcc-' + (fd.get('id') || ''),
                    data: {
                      source: 'product-form-component',
                      itemCount: 1,
                      variantId: fd.get('id'),
                      sections: res.sections
                    }
                  }
                })
              );
            } catch (err) {}
            try {
              window.dispatchEvent(
                new CustomEvent('custom:open-cart-drawer', {
                  detail: { source: 'product-form-component', quantity: 1 }
                })
              );
            } catch (err) {}
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            btn.textContent = 'Try Again';
            btn.disabled = false;
            setTimeout(function () { btn.textContent = original; }, 2000);
          });
      },
      true
    );
  }

  if (!window.__pccBisToast) {
    window.__pccBisToast = true;
    /* Back-in-stock signup confirmation after the customer form redirects back. */
    var pccBis = function () {
      if (window.location.search.indexOf('back_in_stock=1') === -1) return;
      var grid = document.querySelector('.product-grid, [data-testid="resource-list-grid"], results-list');
      var toast = document.createElement('p');
      toast.className = 'pcc-bis-toast';
      toast.textContent = "You're on the list! We'll email you as soon as it's back in stock.";
      if (grid && grid.parentElement) {
        grid.parentElement.insertBefore(toast, grid);
      } else {
        document.body.insertBefore(toast, document.body.firstChild);
      }
      toast.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname);
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pccBis);
    } else {
      pccBis();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
